import React, {useState} from 'react';
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import {useModal} from "../components/Modal";

const Dum4kk = () => {
    Fancybox.bind('.gal-item', {});

    const { handleShowModal } = useModal();

    const floor = "./images/catalogue/4kk/floor-plan.jpg" ;

    return (
        <div id="content" className="catalogue-detail">
            <div className="container">
                <div className="heading">
                    <h1>Dům 4+kk 110 m<sup>2</sup></h1>
                    <small>vyrobeno za 90 dní</small>
                </div>
                <div className="qBox">
                    <div className="item">
                        <span>rozměry domu</span>
                        <div className="d-flex">
                            <strong>13x8,4x4,1 m</strong>
                        </div>
                    </div>
                    <div className="item">
                        <span>střecha</span>
                        <strong>sedlová, sklon 10°</strong>
                        <small>možnost zvýšení sklonu za příplatek</small>
                    </div>
                    <div className="item">
                        <span>užitná plocha</span>
                        <strong>93,5 m<sup>2</sup></strong>
                    </div>
                </div>
                <div className="detail-grid">
                    <div className="left">
                        <div className="preview">
                            <a className="gal-item" href="./images/catalogue/4kk/preview.jpg" data-fancybox="gallery">
                                <img src="./images/catalogue/4kk/preview.jpg" alt="Dům 4+kk 100m" />
                            </a>
                            <div className="tag">
                                energetická třída B - velmi úsporná
                            </div>
                        </div>
                        <div className="gallery">
                            <a className="gal-item" href="./images/gallery/14.jpg" data-fancybox="gallery">
                                <img src="./images/gallery/14.jpg" alt="img14" loading="lazy" />
                            </a>
                            <a className="gal-item" href="./images/gallery/02.jpg" data-fancybox="gallery">
                                <img src="./images/gallery/02.jpg" alt="img02" loading="lazy" />
                            </a>
                            <a className="gal-item" href="./images/gallery/09.jpg" data-fancybox="gallery">
                                <img src="./images/gallery/09.jpg" alt="img09" loading="lazy" />
                            </a>
                            <a className="gal-item" href="./images/gallery/06.jpg" data-fancybox="gallery">
                                <img src="./images/gallery/06.jpg" alt="img06" loading="lazy" />
                            </a>
                            <a className="gal-item" href="./images/gallery/07.jpg" data-fancybox="gallery">
                                <img src="./images/gallery/07.jpg" alt="img07" loading="lazy" />
                            </a>
                            <a className="gal-item" href="./images/gallery/08.jpg" data-fancybox="gallery">
                                <img src="./images/gallery/08.jpg" alt="img08" loading="lazy" />
                            </a>
                        </div>
                    </div>
                    <div className="right">
                        <div className="inquiry-box">
                            <h2>Cena domu na klíč</h2>
                            <div className="price">
                                <span>4 995 000 Kč</span>
                                <small>včetně DPH a&nbsp;základových patek</small>
                            </div>
                            <button onClick={handleShowModal} className="bttn inquiry">Mám zájem</button>
                        </div>
                        <div className="info">
                            <h2>Služby a vybavení zahrnuté v ceně</h2>
                            <div>
                                <img src="./images/catalogue/car.svg" alt="doprava" />
                                doprava do 100 km od výrobní haly
                            </div>
                            <div>
                                <img src="./images/catalogue/bricks.svg" alt="patky" />
                                základové patky na rovinnatém pozemku
                            </div>
                            <div>
                                <img src="./images/catalogue/documentation.svg" alt="dokumentace" />
                                projektová dokumentace
                            </div>
                            <ul>
                                <li>podlahové vytápění</li>
                                <li>tepelné čerpadlo</li>
                                <li>fotovoltaika 4 kWp, baterie 6 kWh</li>
                                <li>krbová kamna s komínem</li>
                                <li>el. venkovní žaluzie</li>
                                <li>bojler 120 l</li>
                                <li>sanita - wc, vana / sprchový kout, umyvadlo</li>
                                <li>podlahy, dlažby, obklady</li>
                                <li>interiérové dveře</li>
                                <li>elektroinstalace</li>
                                <li>příprava na kuchyň</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="note">
                    <strong>Poznámka:</strong> Nabídková cena, která zahrnuje dopravu a zhotovení základových patek je platná <strong>pouze v případě standardně očekávaných podmínek</strong>. Pokud se ukáže, že cílový pozemek disponuje horší
                    dostupností pro složení modulu nebo projektant vyhodnotí nutnost realizace zvýšené odolnosti základových patek, bude cena za tyto služby individuálně kalkulována nad rámec prezentované nabídky.
                </div>

                <div className="platform">
                    <h2>Půdorys domu</h2>
                    <div className="preview">
                        <p>Dispozice obytné části domu lze po domluvě přizpůsobit</p>
                        <a className="gal-item" href={floor} data-fancybox="floor">
                            <img src={floor} alt="Půdorys" data-fancybox="floor" loading="lazy" />
                        </a>
                    </div>
                </div>
                <div className="extra-info">
                    <div className="extra-text">
                        <h3>Co si zákazník libovolně vybírá</h3>
                        <ul>
                            <li>Dekor a materiál podlah (v ceně domu započtena sazba 329 Kč/m2)</li>
                            <li>Obklady do koupelny (v ceně domu započtena sazba 329 Kč/m2)</li>
                            <li>Dekor a styl interiérových dveří</li>
                            <li>Osvětlení, zásuvky a vypínače</li>
                            <li>Vanu nebo sprchový kout</li>
                            <li>Toaletu a umyvadlo</li>
                        </ul>
                    </div>
                    <div className="extra-banner">
                        <h2>
                            Máte zájem o individuální
                            vybavení domu?
                        </h2>
                        <p>
                            Neváhejte nás kontaktovat. Upravíme vám nabídku
                            dle vašich potřeb a požadavků.
                        </p>
                        <button onClick={handleShowModal} className="bttn center">Kontaktní formulář</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Dum4kk;

